// extracted by mini-css-extract-plugin
module.exports = {"FooterNewsletter":"styles_FooterNewsletter__7PRZk","headline":"styles_headline___XMQ9","text":"styles_text__xtSMK"};